import { CellSelections } from '../../../../../../../common/table/TableTypes';
import hyperFormulaInstance from '../../../manager/hyperFormulaInstance';
import { getAllCellsBetween } from '../../../../bridge/utils/selectionUtils/tableSelectionGeometryUtils';
import { getHotTableCellData } from '../../../../bridge/utils/hotInstanceUtils/meta/hotTableCellMetaUtils';
import type { MNHotInstance } from '../../../../bridge/tableHotInstanceTypes';

/**
 * Logs the current Handsontable instance for table debugging.
 */
export const debugTableInstance = (hotInstance: MNHotInstance): void => {
    console.info(hotInstance);
};

/**
 * Logs the selected cells and formula-engine state for the given cell selections.
 */
export const debugTableCells = (
    hotInstance: MNHotInstance,
    elementId: string,
    cellSelections: CellSelections,
): void => {
    getAllCellsBetween(cellSelections).forEach(({ row, col }) => {
        const sheet = hyperFormulaInstance.getSheetId(elementId);

        const formulaInfo =
            sheet === undefined
                ? {}
                : {
                      hfCellValue: hyperFormulaInstance.getCellValue({ sheet, row, col }),
                      hfCellType: hyperFormulaInstance.getCellType({ sheet, row, col }),
                      hfCellValueType: hyperFormulaInstance.getCellValueType({ sheet, row, col }),
                      hfCellValueDetailedType: hyperFormulaInstance.getCellValueDetailedType({ sheet, row, col }),
                  };

        console.info({
            row,
            col,
            cellData: getHotTableCellData(hotInstance, { row, col }),
            ...formulaInfo,
        });
    });
};
